import React, { useState } from 'react';
import Icon from '@common/assets';
import WelfareModal from './welfareModal';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './welfare.module.scss';
const cx = classnames.bind(styles);

interface WelfareProps {
  positionSn?: number;
  positionDetail: PositionDetailVO;
}

const Welfare = ({ positionSn, positionDetail }: WelfareProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const { additionalInfo } = positionDetail;

  const welfareEls = additionalInfo.welfareWithCategories?.map((category, i) => (
    <li key={i} className={cx('listItem')}>
      {category.welfares[0]}
    </li>
  ));

  const getWelfareCount = () => {
    return additionalInfo.welfareWithCategories?.reduce((prev, cur) => {
      return prev + (cur.welfares?.length ?? 0);
    }, 0);
  };

  const handleClick = () => {
    if (!positionSn) return;
    setModalVisible(true);
  };

  const isWelfare = !!(getWelfareCount() ?? 0);

  if (!isWelfare) return null;

  return (
    <div className={cx('welfareWrap')}>
      <div className={cx('titleArea')}>
        <Icon name="diamondLight" width={32} height={32} />
        <em className={cx('title')}>이런 복지들이 있어요.</em>
      </div>

      <div className={cx('welfareArea')}>
        <ul className={cx('welfareList')}>
          {welfareEls}
          <li className={cx('listItem', 'more')}>
            <a className={cx('btnMore')} role="button" onClick={handleClick}>
              {getWelfareCount()}개 보유복지 모두보기
            </a>
          </li>
        </ul>

        <WelfareModal positionDetail={positionDetail} visible={modalVisible} onClose={() => setModalVisible(false)} />
      </div>
    </div>
  );
};

export default Welfare;
